import { useState } from "react";
import { Flex, OverlayStyle, SlideoutDrawerV2, Tab, Tabs, Text } from "@jsq/ds/core";
import { type useGetGroupsQuery } from "~/graphql/mainHooks";
import { AssignedUsersTab } from "./components/AssignedUsersTab";
import { PermissionsTab } from "./components/PermissionsTab";
import * as styles from "./styles_vanilla.css";

type GroupsData = ReturnType<typeof useGetGroupsQuery>["data"];

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  roleId: string | undefined;
  groupsData?: GroupsData;
};

enum TabType {
  Permissions = "Permissions",
  AssignedUsers = "Assigned users",
}

const CanopyRoleDetails = ({ isOpen, onClose, title, roleId, groupsData }: Props) => {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.Permissions);

  return (
    <SlideoutDrawerV2
      isOpen={isOpen}
      onClose={onClose}
      isDismissable
      overlayStyle={OverlayStyle.Transparent}
      data-testid="canopy-role-details-drawer"
    >
      <SlideoutDrawerV2.ComplexHeader
        title={title}
        subtitles={[
          <Text key="subtitle" variant="secondary-md" asSpan>
            Canopy role
          </Text>,
        ]}
        className={styles.slideoutHeader}
      />
      <SlideoutDrawerV2.Body className={styles.drawerBody}>
        <Flex flexDirection="column" className={styles.container}>
          <Tabs key="tabs" className={styles.tabs}>
            <Tab
              data-testid="permissions-tab"
              active={activeTab === TabType.Permissions}
              text="Permissions"
              onClick={() => setActiveTab(TabType.Permissions)}
            />
            <Tab
              data-testid="assigned-users-tab"
              active={activeTab === TabType.AssignedUsers}
              text="Assigned users"
              onClick={() => setActiveTab(TabType.AssignedUsers)}
            />
          </Tabs>
          <div className={styles.tabContent}>
            {activeTab === TabType.Permissions && (
              <PermissionsTab title={title} groupsData={groupsData} />
            )}
            {activeTab === TabType.AssignedUsers && <AssignedUsersTab groupId={roleId} />}
          </div>
        </Flex>
      </SlideoutDrawerV2.Body>
    </SlideoutDrawerV2>
  );
};

export default CanopyRoleDetails;
